import { ArrowDownLeft, ArrowUpRight, Check, Clock, X } from "lucide-react";
import { formatINR } from "@/lib/format";

const PILL = "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium border";

const TXN_STYLES = {
  credit: { cls: "text-emerald-700 bg-emerald-50 border-emerald-200", Icon: ArrowDownLeft, label: "Credit" },
  debit: { cls: "text-red-700 bg-red-50 border-red-200", Icon: ArrowUpRight, label: "Debit" },
};

const STATUS_STYLES = {
  pending: { cls: "text-amber-800 bg-amber-50 border-amber-200", Icon: Clock, label: "Pending" },
  rejected: { cls: "text-red-700 bg-red-50 border-red-200", Icon: X, label: "Rejected" },
  approved: { cls: "text-emerald-700 bg-emerald-50 border-emerald-200", Icon: Check, label: "Approved" },
};

const Pill = ({ style }) => (
  <span className={`${PILL} ${style.cls}`}>
    <style.Icon className="h-3 w-3" /> {style.label}
  </span>
);

export const TxnTypeBadge = ({ type }) => <Pill style={TXN_STYLES[type] || TXN_STYLES.debit} />;

export const StatusBadge = ({ status }) => (
  <Pill style={STATUS_STYLES[status] || STATUS_STYLES.approved} />
);

export const TxnAmount = ({ type, amount }) => {
  const isCredit = type === "credit";
  return (
    <span className={isCredit ? "text-emerald-700" : "text-red-700"}>
      {isCredit ? "+" : "−"}
      {formatINR(amount)}
    </span>
  );
};
